export const contactUs = {
  contactInformation: 'Contact',
  projectBackground: 'Introduction',
}
